// User-controlled text size preference — persisted in localStorage and applied
// as a class on <html> so all rem-based Tailwind text scales together.
const KEY = "icard_text_size";
export const TEXT_SIZES = ["small", "normal", "large"];

export function getTextSize() {
  try {
    const v = localStorage.getItem(KEY);
    return TEXT_SIZES.includes(v) ? v : "normal";
  } catch {
    return "normal";
  }
}

export function applyTextSize(size = getTextSize()) {
  const el = document.documentElement;
  el.classList.remove("txt-small", "txt-large");
  if (size === "small") el.classList.add("txt-small");
  else if (size === "large") el.classList.add("txt-large");
}

export function setTextSize(size) {
  try { localStorage.setItem(KEY, size); } catch {}
  applyTextSize(size);
}
